<template>
  <div class="not-front documents">

    <AdminHeader/>

    <div id="mainwrapper">
      <div class="container">

        <AdminSidebar/>

        <router-view />
        
      </div>
    </div>  
  </div>
</template>

<script>
import AdminSidebar from '@/components/app/admin/AdminSidebar.vue'
import AdminHeader from '@/components/app/admin/AdminHeader.vue'

export default {
  name: 'admin-layout',
  components: {
    AdminSidebar, AdminHeader,
  }
}
</script>
